var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entity-properties-row d-flex flex-wrap mb-1 align-baseline",class:_vm.$vuetify.breakpoint.name},[_c('label',{staticClass:"input-label pt-3 pb-1 pb-sm-2"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"flex-grow-1"},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.property))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }